/*@ngInject*/
const ManagePopupNotificationHeaderController = function ($rootScope, $scope, $element, $stateParams, $state, $uibModal, localization, configurationConstant, notificationPopupTemplateRepository, notificationPopupTemplateModel, configurationMediator, coreConstant, modalUtil, notificationPreferencesAction, configurationActionsUtil, loadingBarHandler, navigationStateModel) {

    $element.addClass('managePopupNotificationHeader');

    this.notificationPopupTemplateModel = notificationPopupTemplateModel;

    this.translations = null;
    this.actions = [];
    this.context = {
        identifier: 'managePopupNotificationHeader',
        actions: {},
        fallthrough: null,
        model: {
            contextType: coreConstant.CONTEXT_NONE
        }
    };
    this.context.actions[coreConstant.CONTEXT_NONE] = '';
    this.actionSubTexts = {};
    this.actionsTimeLastModified = '';

    this.$onInit = function () {
        localization.getTranslationByKey('managePopupNotificationHeader').then((translations) => {
            this.translations = translations;
            this.actions = [];
            this.loadActions();
        });
    };

    $scope.$on(configurationConstant.event.EMAIL_TEMPLATE_UPDATED, () => {
        this.processActions(this.actions);
    });

    this.loadActions = function () {
        let templateId = $stateParams.templateId;
        if (!templateId) {
            // new template, pass a dummy id
            templateId = -1;
        }
        notificationPopupTemplateRepository.loadActions(templateId).then((actions) => {
            const allActions = [];
            allActions.push({
                actions: actions.actions,
                contextType: this.context.model.contextType
            });
            this.actions = allActions;
            this.actionsTimeLastModified = new Date().getTime();
            this.processActions(allActions, false);
        });
    };

    this.processActions = function (actions) {
        this.actions = actions;
        this.actionSubTexts = {};

        _.each(this.actions, (subAction) => {
            _.each(subAction.actions, (action) => {
                if (action.name === notificationPreferencesAction.SAVE) {
                    action.enabled = notificationPopupTemplateModel.hasUnsavedChanges && notificationPopupTemplateModel.isValid;
                } else if (action.name === notificationPreferencesAction.DISCARD) {
                    action.enabled = notificationPopupTemplateModel.hasUnsavedChanges || !$stateParams.templateId;
                } else if (action.name === notificationPreferencesAction.DELETE) {
                    action.enabled = !_.isEmpty($stateParams.templateId);
                }

                if (action.name === notificationPreferencesAction.SAVE && notificationPopupTemplateModel.hasUnsavedChanges) {
                    this.actionSubTexts[action.name] = {
                        class: 'unsavedChanges',
                        text: _.get(this.translations, 'unsavedChanges')
                    };
                }
            });
        });

        this.actionsTimeLastModified = new Date().getTime();
    };

    $scope.$on(configurationConstant.event.PRODUCT_TEMPLATE_UPDATED, () => {
        this.processActions(this.actions);
    });

    this.handleAction = function (action) {
        if (action.enabled) {
            switch (action.name) {
                case notificationPreferencesAction.SAVE:
                    configurationActionsUtil.saveNotificationPopupTemplate(notificationPopupTemplateModel.notificationPopupTemplate).then(function (popupTemplate) {
                        if (!_.isNil(popupTemplate)) {
                            $stateParams.templateId = popupTemplate.id;
                        }
                        $state.reload();
                    });
                    break;

                case notificationPreferencesAction.DISCARD:
                    modalUtil.showConfirmationModal(null, null, null, 'managePopupNotificationHeader.discardConfirmation', null, true, () => {
                        $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(this.translations, 'discardConfirmation.success'));
                        notificationPopupTemplateModel.hasUnsavedChanges = false;
                        if ($stateParams.templateId) {
                            $state.reload();
                        } else {
                            $state.go('configuration.popupBrowser', {});
                        }
                    });
                    break;

                case notificationPreferencesAction.DELETE:
                    modalUtil.showConfirmationModal(null, null, null, 'managePopupNotificationHeader.deleteConfirmation', null, true, () => {
                        $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(this.translations, 'deleteConfirmation.success'));
                        return notificationPopupTemplateRepository.deleteNotificationPopupTemplate(notificationPopupTemplateModel.notificationPopupTemplate.id).then(function (popupTemplate) {
                            notificationPopupTemplateModel.hasUnsavedChanges = false;
                            $state.go('configuration.popupBrowser', {});
                        });
                    });
                    break;

                default:
                    modalUtil.showActionNotImplementedModal(action.name);
                    break;
            }
        }
    };

    this.navigateToPopup = function () {
        $state.go('configuration.popupBrowser', null);
        navigationStateModel.saveViewState('configuration.popupBrowser', null);
    }

    $scope.$on('$stateChangeStart', (event, toState, toParams, fromState) => {
        const isCurrentStateNotificationPopupTemplateManager = _.startsWith(fromState.name, 'configuration.managePopup'),
            isTargetSameAsCurrent = toState.name === fromState.name;

        if (toState.name === 'login') {
            return;
        }

        if (notificationPopupTemplateModel.hasUnsavedChanges && isCurrentStateNotificationPopupTemplateManager &&
            !isTargetSameAsCurrent && notificationPopupTemplateModel.notificationPopupTemplate) {
            event.preventDefault();
            if (notificationPopupTemplateModel.isValid) {
                loadingBarHandler.showNotificationLoadingBar(_.get(this.translations, 'saveNotificationPopupTemplate.loadingBar'));
                notificationPopupTemplateRepository.saveNotificationPopupTemplate(notificationPopupTemplateModel.notificationPopupTemplate).then(() => {
                    loadingBarHandler.concludeNotificationLoadingBar(_.get(this.translations, 'saveNotificationPopupTemplate.savingNotificationPopupTemplateSuccessLoadingBar'));
                    notificationPopupTemplateModel.reset();
                    $state.go(toState, toParams);
                });
            } else {
                $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(this.translations, 'invalidNotificationPopupTemplate'));
            }
        } else {
            // there are no changes to be saved, do nothing
        }
    });
};

angular.module('ums.configuration')
    .controller('managePopupNotificationHeaderController', ManagePopupNotificationHeaderController);
